import React, { Component } from 'react';
import NavTools from '../../tools/NavTools';
import { Link } from "react-router-dom";
import SoundRepository from '../../game/handlers/SoundRepository';
import PrevButton from '../../small-components/prev-button/PrevButton';
import InstructionsData from './InstructionsData';
import FoodCard from './FoodCard';
import '../General.css';
import './Instructions.css';

class Instructions extends Component {

    constructor(props) {
        super(props);

        this.soundRepository = SoundRepository;
    }

    boldStaredText = (string, key = 0) => {
        let stringArr = string.split('*');
        let children = [];

        for (let i = 0; i < stringArr.length; i += 2) {
            let text = this.addNewLine(stringArr[i]);
            let boldText = i + 1 < stringArr.length ? <b>{this.addNewLine(stringArr[i + 1])}</b> : '';
            let child = <span key={i}>{text}{boldText}</span>;
            children.push(child);
        }

        let res = React.createElement("p", { key: key }, children);

        return res;
    }

    addNewLine = (string, key = 0) => {
        let stringArr = string.split('|');
        let children = [];

        for (let i = 0; i < stringArr.length; i += 2) {
            let textA = stringArr[i];
            let textB = i + 1 < stringArr.length ? <span><br />{stringArr[i + 1]}</span> : '';
            let child = <span key={i}>{textA}{textB}</span>;
            children.push(child);
        }

        let res = React.createElement("span", { key: key }, children);

        return res;
    }

    formatText = (string, key) => {
        return this.boldStaredText(string, key);
    }

    render() {

        return (
            <div className="page">

                <PrevButton pageProps={this.props} />

                <div className="instructions-page">
                    <img className="logo" src={require('../../media/images/icons/logo.png')} alt="game-logo" />
                    <div className="cover-details">
                        <h1 className="title">{InstructionsData.coverDetails.title}</h1>
                        <h1 className="sub-title">{InstructionsData.coverDetails.subTitle}</h1>
                        <br />
                        <h2 className="creator-name">{InstructionsData.coverDetails.creatorName}</h2>
                        <h2 className="creator-description">{InstructionsData.coverDetails.creatorDescription}</h2>
                    </div>

                    <div className="generl-information">
                        {InstructionsData.generalInformation.map((info, i) =>
                            <div key={info.title} className="info">
                                <h1 className="blue-title">{info.title}</h1>
                                {this.formatText(info.content, i)}
                            </div>)}
                    </div>

                    <div className="start-game" onClick={() => NavTools.redirect(this.props, '/game')}>
                        <span>מתחילים לשחק</span>
                        <div>
                            <img src={require('../../media/images/icons/start-arrow.png')} alt="start-arrow" />
                        </div>
                    </div>

                    <hr />

                    <div className="contact-details">
                        <h1>{InstructionsData.contactDetails.title}</h1>
                        {InstructionsData.contactDetails.content.map(detail =>
                            detail.isLink ?
                                <div key={detail.title} className="detail">
                                    <p>{detail.title} <a href={detail.content}>{detail.content}</a></p>
                                </div> :
                                <div key={detail.title} className="detail">
                                    <p>{detail.title} {detail.content}</p>
                                </div>)}
                        <br />
                        <div className="detail">
                            <p><Link to="/privacy-policy">תנאי השימוש</Link></p>
                        </div>
                    </div>

                    <img className="about-the-game-logo" src={require('../../media/images/icons/logo.png')} alt="game-logo" />
                    <div className="about-the-game">
                        <h1>{InstructionsData.aboutTheGame.title}</h1>
                        {this.formatText(InstructionsData.aboutTheGame.content)}
                    </div>

                    <div className="action-cards">
                        <h1 className="blue-title">{InstructionsData.actionCards.title}</h1>
                        {InstructionsData.actionCards.content.map(card =>
                            <div key={card.cardTypeName} className="card-row">
                                <div className="card">
                                    <img src={require(`../../media/images/cards/${card.imgName}.png`)} alt={card.imgName} />
                                    <p><span>{card.amount} קלפי {card.cardTypeName} -</span> {card.description}</p>
                                </div>
                                <hr />
                            </div>)}
                    </div>

                    <div className="food-cards">
                        {InstructionsData.foodCards.map(cardType =>
                            <div key={cardType.cardTypeName} className="cardType">
                                <h1 className={cardType.backgroundColor}>{cardType.cardTypeName}</h1>
                                <div className="foods">
                                    {cardType.foods.map(food =>
                                        <FoodCard key={food.name} name={food.name} imgName={food.imgName} description={food.description} backgroundColor={cardType.backgroundColor} />)}
                                </div>
                            </div>)}
                    </div>
                </div>
            </div>
        );
    }
}

export default Instructions;
